import { AutoComplete } from './AutoComplete';

export default AutoComplete;
